import { Haptics, ImpactStyle, NotificationType } from "@capacitor/haptics";
import { isNative } from "./platform";

export interface HapticService {
 selection(): Promise<void>;
 light(): Promise<void>;
 medium(): Promise<void>;
 success(): Promise<void>;
 warning(): Promise<void>;
 error(): Promise<void>;
}

async function safeHaptic(fn: () => Promise<void>): Promise<void> {
 if (!isNative) return;
 try {
 await fn();
 } catch {
 // Haptics unavailable - ignore
 }
}

export const hapticService: HapticService = {
 selection: () => safeHaptic(() => Haptics.selectionChanged()),
 light: () => safeHaptic(() => Haptics.impact({ style: ImpactStyle.Light })),
 medium: () => safeHaptic(() => Haptics.impact({ style: ImpactStyle.Medium })),
 success: () =>
 safeHaptic(() => Haptics.notification({ type: NotificationType.Success })),
 warning: () =>
 safeHaptic(() => Haptics.notification({ type: NotificationType.Warning })),
 error: () =>
 safeHaptic(() => Haptics.notification({ type: NotificationType.Error })),
};
